declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";

import { Router, ActivatedRoute } from '@angular/router';




declare var require: any;


import { NgbModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
import { NgbAddBill } from './modal/addbill.modal';
import { NgbSearchPatientModal } from '../follow up/counsellingregistry/modal/searchpatient.modal';
import { BillDetailsInfoController, x_BillDetailsRequest, X_BillHeaderController, X_BillItemsController, X_BillReceiptsController, SaveBillItemsInfoRequest, CancelBillRequest, X_BillHeaderByProviderCodeController, X_BillItemsByProviderCodeController, X_BillReceiptsByProviderCodeController, x_BillDetailsByProviderCodeRequest, BillDetailsByProviderCodeInfoController, SaveAdmissionLabDetails, GenericProcPostRequest, S_Methods } from '../../../models/actor/actor';
import { AppData } from '../../../models/appdata';
import { ActorService } from '../../../services/actor.service';
import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { ApiResponseModel } from '../../../models/api_response_model';
import { SpinnerService } from '../../../services/spinner.service';
//import { billingpipe } from '../../../pipes/actors/actorIdentity.pipes';
//import { Pipe } from '@angular/core';
//import { Injectable } from '@angular/core';
//import { PipeTransform } from '@angular/core';
import { BillingPipe } from '../../../pipes/actors/actorIdentity.pipes';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
import { NgbPaymentModeChangeModal } from './modal/paymentmodechange.modal';
import { NGXToastrService } from '../../../../shared/services/toastr.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbCombinebillSearchPatientModal } from '../follow up/counsellingregistry/modal/combinebillsearchpatient.modal';
import { NgbChangeDateModal } from './modal/changedate.modal';



@Component({
  selector: 'opbillingnp',
  templateUrl: './opbillingnp.component.html',
  styleUrls: [
    './opbillingnp.component.scss']
  , animations: [routerTransition()]
})

export class OpBillingNPComponent implements OnInit {

  @Input() public FromScreen: string = "NONE";
  @Input() public marginTop: number = 18;

  public ApiResData: ApiResponseModel;
  public ActorCode: number = 0;
  public FormattedCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
  public Showrow: boolean = true;
  public SelectedFormattedCode: string;
  public ShowPatientDetails: boolean = false;
  public isRequesting: boolean = false;
  public billdetails1: boolean = false;
  public ChargeEntryCode: number;
  public billdetails2: boolean = false;
  public PatientName: string;
  public PayeeName: string;
  public Toatalbill: number;
  public PaidBill: number;
  public searchValue: string;
  public DiscountMode: string;
  searchTitle: string;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  TodayDate = new Date();
  SelectedFromDate: NgbDateStruct;
  CurrentBillDetailsInfoController: X_BillHeaderController[];
  CurrentBillDetailsInfoControllernew: X_BillHeaderController[];
  SelectedBillType: X_BillHeaderController[];
  Currentx_BillDetailsRequest: x_BillDetailsRequest;

  LoadForms() {
    this.Currentx_BillDetailsRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.Currentx_BillDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.pdata = this.CurrentBillDetailsInfoController;
    this.GetBillDetailsInfoController();
  }
  public SelectedReport: string;

  GetBillDetailsInfoController() {
    this.StartRefreshing();
    //this.spinner.show();
    this.Currentx_BillDetailsRequest.Branch = AppData.Instance().SelectedBranchCode;
    if (this.SelectedFromDate != null) {
      this.Currentx_BillDetailsRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
      this.Currentx_BillDetailsRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    } else {
      var d = new Date();
      d.setHours(0, 0, 0, 0);
      this.Currentx_BillDetailsRequest.FromDate = d;
      this.Currentx_BillDetailsRequest.ToDate = d;
    }
    this.Currentx_BillDetailsRequest.ChargeEntry = 0;
    this.Currentx_BillDetailsRequest.ConditionalOperator = 10;
    this.Currentx_BillDetailsRequest.BillType = '';
    this.Currentx_BillDetailsRequest.FormattedCode = '';
    this.Currentx_BillDetailsRequest.SearchText = '';

    //alert(this.FormattedCode);
    this.actorservice.GetBillDetailsInfoController(this.Currentx_BillDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentBillDetailsInfoController = this.ApiResData.Result;
          this.CurrentBillDetailsInfoControllernew = this.CurrentBillDetailsInfoController.filter(
            function (a) {
              return a.BillType != 'RXBILL';
            });
          this.pdata = this.CurrentBillDetailsInfoControllernew;
          this.SelectedBillType = this.CurrentBillDetailsInfoController;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
          //this.spinner.hide();
          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadOvaryData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  LoadBillsGeneric() {
    var getReq = new x_BillDetailsRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.Branch = AppData.Instance().SelectedBranchCode;
    if (this.SelectedFromDate != null) {
      getReq.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
      getReq.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    } else {
      var d = new Date();
      d.setHours(0, 0, 0, 0);
      getReq.FromDate = d;
      getReq.ToDate = d;
    }
    getReq.ChargeEntry = 0;
    getReq.ConditionalOperator = 101053;
    getReq.BillType = '';
    getReq.FormattedCode = '';
    getReq.SearchText = '';
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101053;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          this.CurrentBillDetailsInfoController = JSON.parse(data);
          this.CurrentBillDetailsInfoControllernew = this.CurrentBillDetailsInfoController.filter(
            function (a) {
              return a.BillType != 'RXBILL';
            });
          this.pdata = this.CurrentBillDetailsInfoControllernew;
          this.SelectedBillType = this.CurrentBillDetailsInfoController;          
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

    CurrentSaveBillItemsInfoRequest: SaveBillItemsInfoRequest;
  constructor(private router: Router,
    public printService: PrintService,
    private modalService: NgbModal,
    private actorservice: ActorService,
    private route: ActivatedRoute,
    private loaderService: SpinnerService,
    private parserFormatter: NgbDateParserFormatter,
      private filter: BillingPipe, private tosterservice: NGXToastrService, private spinner: NgxSpinnerService,

    
  ) { }

  ngOnInit() {
    this.DiscountMode = AppData.Instance().GetDataParam('Discount Mode');
    //this.DiscountMode = 'Bill Level';
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.LoadBillsGeneric();
    // this.pdata = this.CurrentBillDetailsInfoController;
      this.CurrentSaveBillItemsInfoRequest = new SaveBillItemsInfoRequest();
      this.CurrentSaveBillItemsInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }



  ShowList: boolean = true;



  BackToProfile() {
    this.ShowList = true;
    this.ShowPatientDetails = false;
    this.Showarrow = false;
  }


  clearData() {
    this.isNew = true;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }
  ChangeDate() {
    const modalRef = this.modalService.open(NgbChangeDateModal,
      {
        centered: true,
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.BillNo = this.CurrentX_BillHeaderController.BillNo;
    modalRef.componentInstance.CurrentDate = this.CurrentX_BillHeaderController.BillCreatedDate;
    modalRef.componentInstance.ChargeEntry = this.SelectedpatientDetails.ChargeEntry;
    modalRef.result.then(x => { this.GetX_BillHeaderController() })
  }
  AddNewBill_svcprovider() {

    const modalRef = this.modalService.open(NgbSearchPatientModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })

    modalRef.result.then((val: string) => {


      this.router.navigate(['healins/receipt_svcprovider', { Formattedcodedata: val }]);
      modalRef.componentInstance.FormattedCode = val;
      // this.SelectedFormattedCode = val;

      //modalRef.componentInstance.PatientName = val;
      //modalRef.componentInstance.PatientRegistrationNumber = val;
      //modalRef.result.then(x => { this.GetPatientInfoByFormattedCodeController() })
    });
  }
  AddNewBill() {

    const modalRef = this.modalService.open(NgbSearchPatientModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })

    modalRef.result.then((val: string) => {


      this.router.navigate(['healins/receipt', { Formattedcodedata: val }]);
      modalRef.componentInstance.FormattedCode = val;
      // this.SelectedFormattedCode = val;

      //modalRef.componentInstance.PatientName = val;
      //modalRef.componentInstance.PatientRegistrationNumber = val;
      //modalRef.result.then(x => { this.GetPatientInfoByFormattedCodeController() })
    });
  }
  ViewPatientDetails() {
    this.router.navigate(['healins/billview']);
  }
  CancelNewOperation() {

    this.ShowList = true;
    }
  SelectedpatientDetails: X_BillHeaderController;
  Selectedpatient(objCategory: any) {
    var patient: X_BillHeaderController = objCategory;
    if (patient != null) {
      //alert(patient.ChargeEntry);
      this.SelectedpatientDetails = null;
      this.SelectedpatientDetails = patient;

      this.billdetails1 = true;
      this.billdetails2 = true;
      this.LoadBillHeader();
      this.LoadBillItems();
      this.LoadProviderBillHeader();
      this.LoadBillReceipts();
    }


  }
  CanCancel(): boolean {
    var billdate = new Date(this.SelectedpatientDetails.BillCreatedDate);//.getDate();
    var today = new Date();//.getDate();
    if (billdate.getDate() == today.getDate() &&
      billdate.getMonth() == today.getMonth() &&
      billdate.getFullYear() == today.getFullYear()
    )
      return true; // go ahead and cancel
    else
      return false;
  }
  Cancel() {
    if (!this.CanCancel()) {
      alertFunctions.AlertParam("Selected Bill Cannot be cancelled" + "...!" + "Only Bills that are generated today can be cancelled");
      return;
    }
    else {
        swal({
            title: 'Bill Cancellation',
            text: "Press Yes Button to Submit Request for Cancellation",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0CC27E',
            cancelButtonColor: '#FF586B',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            confirmButtonClass: 'btn btn-success btn-raised mr-5',
            cancelButtonClass: 'btn btn-danger btn-raised',
            allowOutsideClick: false,
            buttonsStyling: false
        }).then(() => {

            this.Cancel2();

            //this.DeleteActorIdentitiesMedicine(l);
            // alertFunctions.AlertParam('Delete Successfully...!');

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                swal(
                    'Cancelled',
                    'Remove Bill Operation Cancelled :)',
                    'error'
                )
            }
        })
    }
 }
   
    Cancel2() {
        this.spinner.show();
        //this.CurrentSaveBillItemsInfoRequest.Bill = this.CurrentNewBillData;
      var c = new CancelBillRequest()
      c.ConditionalOperator = 10;
      c.SendApiRequestModel = this.CurrentSaveBillItemsInfoRequest.SendApiRequestModel;
      c.FacilityCode = this.SelectedpatientDetails.Branch;
      c.ChargeEntry = this.SelectedpatientDetails.ChargeEntry;
        //this.CurrentSaveBillItemsInfoRequest.ChargeEntry = this.SelectedpatientDetails.ChargeEntry.toString();
      //this.CurrentSaveBillItemsInfoRequest.ConditionalOperator = 300;
      this.actorservice.CancelBill(c)
            .subscribe((result) => {

                this.ApiResData = result;
                if (result.Result  > 0) {

                  //alert(result.Result);
                  //alert(result.Result[0].Result);
                  //  this.LChargeEntryCode = this.ApiResData.Result[0].Result;

                    this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

                  this.stopRefreshing();
                  this.spinner.hide();
                  //this.router.navigate(['healins/opbilling']);
                  this.billdetails1 = false;
                  this.billdetails2 = false;
                  //this.LoadForms();
                  this.LoadBillsGeneric();
                }
                else {
                  
                    alertFunctions.AlertParam("Invalid Operation :- " + "...!");


                    this.stopRefreshing();
                    this.spinner.hide();
                }

            },





                (error) => {


                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );
  }

  Cancel3() {

      swal({
        title: 'Bill Cancellation',
        text: "Press Yes Button to Submit Request for Cancellation",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#0CC27E',
        cancelButtonColor: '#FF586B',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        confirmButtonClass: 'btn btn-success btn-raised mr-5',
        cancelButtonClass: 'btn btn-danger btn-raised',
        allowOutsideClick: false,
        buttonsStyling: false
      }).then(() => {

        this.Cancel2();

      }, function (dismiss) {
        if (dismiss === 'cancel') {
          swal(
            'Cancelled',
            'Remove Bill Operation Cancelled :)',
            'error'
          )
        }
      })
    
  }
    
  //Selectedpatient(l: BillDetailsInfoController) {
  //    var chargedentry = l.Header.ChargeEntry;
  //    alert(chargedentry);
  //}
  CurrentX_BillHeaderController: X_BillHeaderController;
  //FollicularScanEndInfo: FollicularScanDetailController;
  // BillHeader: X_BillHeaderController[];
  CurrentX_BillHeaderRequest: x_BillDetailsRequest;

  BillDataHeader: BillDetailsInfoController;

  LoadBillHeader() {
    //alert("ScansData")
    this.CurrentX_BillHeaderRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentX_BillHeaderRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillHeaderController();
  }

  GetX_BillHeaderController() {
    //this.StartRefreshing();

    this.CurrentX_BillHeaderRequest.ChargeEntry = this.SelectedpatientDetails.ChargeEntry;
    // alert(this.SelectedpatientDetails[0].Header[0].ChargeEntry);
    this.CurrentX_BillHeaderRequest.ConditionalOperator = 5;
    //this.Cu
    //alert(this.FormattedCode);

    this.actorservice.GetBillHeaderController(this.CurrentX_BillHeaderRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.BillDataHeader = this.ApiResData.Result;
          this.CurrentX_BillHeaderController = this.BillDataHeader.Header;
          // this.ChargeEntryCode = this.CurrentX_BillHeaderController[0].ChargeEntry;
          //alert(this.CurrentX_BillHeaderController[0].PatientName);
          //this.CurrentX_BillHeaderController = this.BillDataHeader.Header;
          // this.CurrentX_BillHeaderController[0].PatientName;
          //alert(this.CurrentX_BillHeaderController);
          //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentX_BillItemsController: X_BillItemsController[];
  //FollicularScanEndInfo: FollicularScanDetailController;
  //BillHeader: X_BillHeaderController[];
  CurrentX_BillItemsRequest: x_BillDetailsRequest;

  BillData: BillDetailsInfoController;

  LoadBillItems() {
    //alert("ScansData")
    this.CurrentX_BillItemsRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentX_BillItemsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillItemsController();
  }

  GetX_BillItemsController() {
    //this.StartRefreshing();

    this.CurrentX_BillItemsRequest.ChargeEntry = this.SelectedpatientDetails.ChargeEntry;
    // alert(this.SelectedpatientDetails[0].Header[0].ChargeEntry);
    this.CurrentX_BillItemsRequest.ConditionalOperator = 5;
    //this.Cu
    //alert(this.FormattedCode);

    this.actorservice.GetBillItemsController(this.CurrentX_BillItemsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();

          this.BillData = this.ApiResData.Result;
          this.CurrentX_BillItemsController = this.BillData.Items;
          this.ChargeEntryCode = this.SelectedpatientDetails.ChargeEntry;
          // this.CurrentX_BillHeaderController[0].PatientName;
          //alert(this.CurrentX_BillHeaderController);
          //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentX_BillReceiptsController: X_BillReceiptsController[];

  CurrentX_BillReceiptsRequest: x_BillDetailsRequest;

  BillDataReceipt: BillDetailsInfoController;

  LoadBillReceipts() {
    //alert("ScansData")
    this.CurrentX_BillReceiptsRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentX_BillReceiptsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillReceiptsController();
  }

  GetX_BillReceiptsController() {
    //this.StartRefreshing();

    this.CurrentX_BillReceiptsRequest.ChargeEntry = this.SelectedpatientDetails.ChargeEntry;
    // alert(this.SelectedpatientDetails[0].Header[0].ChargeEntry);
    this.CurrentX_BillReceiptsRequest.ConditionalOperator = 5;
    //this.Cu
    //alert(this.FormattedCode);

    this.actorservice.GetBillReceiptsController(this.CurrentX_BillReceiptsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();

          this.BillDataReceipt = this.ApiResData.Result;
          this.CurrentX_BillReceiptsController = this.BillDataReceipt ? this.BillDataReceipt.Receipts : undefined;
          if (this.CurrentX_BillReceiptsController && this.CurrentX_BillReceiptsController.length > 0) {
            this.PatientName = this.CurrentX_BillReceiptsController[0].PatientName;
            this.PayeeName = this.CurrentX_BillReceiptsController[0].PayeeName;
            this.Toatalbill = this.CurrentX_BillReceiptsController[0].AmountPayable;
            this.PaidBill = this.CurrentX_BillReceiptsController[0].AmountPaid;
          }



          // this.CurrentX_BillHeaderController[0].PatientName;
          //alert(this.CurrentX_BillHeaderController);
          //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentX_BillHeaderByProviderCodeController: X_BillHeaderByProviderCodeController;
  CurrentX_BillItemsByProviderCodeController: X_BillItemsByProviderCodeController[];
  CurrentX_BillReceiptsByProviderCodeController: X_BillReceiptsByProviderCodeController[];

  Currentx_BillDetailsByProviderCodeRequest: x_BillDetailsByProviderCodeRequest;
  BillData2: X_BillItemsByProviderCodeController;
  ProviderBillDataHeader: BillDetailsByProviderCodeInfoController;

  LoadProviderBillHeader() {
    this.Currentx_BillDetailsByProviderCodeRequest = new x_BillDetailsByProviderCodeRequest();
    this.Currentx_BillDetailsByProviderCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillHeaderByProviderCodeController();
  }
  GetX_BillHeaderByProviderCodeController() {
    this.Currentx_BillDetailsByProviderCodeRequest.ChargeEntry = this.SelectedpatientDetails.ChargeEntry;
    this.Currentx_BillDetailsByProviderCodeRequest.ConditionalOperator = 5;
    this.actorservice.GetBillDetailsByProviderCode(this.Currentx_BillDetailsByProviderCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.ProviderBillDataHeader = this.ApiResData.Result;
          this.CurrentX_BillHeaderByProviderCodeController = this.ProviderBillDataHeader.Header;
          this.CurrentX_BillItemsByProviderCodeController = this.ProviderBillDataHeader.Items;
          this.CurrentX_BillReceiptsByProviderCodeController = this.ProviderBillDataHeader.Receipts;
          this.BillData2 = this.CurrentX_BillItemsByProviderCodeController[0];
          this.ChargeEntryCode = this.SelectedpatientDetails.ChargeEntry;
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  dataChanged(newobj) {
    this._LoadBillsGeneric();
    //this._GetBillDetailsInfoController()
  }
  _GetBillDetailsInfoController() {
    this.StartRefreshing();
    //this.spinner.show();
    this.Currentx_BillDetailsRequest.Branch = AppData.Instance().SelectedBranchCode;
    this.Currentx_BillDetailsRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.Currentx_BillDetailsRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.Currentx_BillDetailsRequest.ChargeEntry = 0;
    this.Currentx_BillDetailsRequest.ConditionalOperator = 10;
    this.Currentx_BillDetailsRequest.BillType = '';
    this.Currentx_BillDetailsRequest.FormattedCode = '';
    //alert(this.FormattedCode);
    this.actorservice.GetBillDetailsInfoController(this.Currentx_BillDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentBillDetailsInfoController = this.ApiResData.Result;
          this.CurrentBillDetailsInfoControllernew = this.CurrentBillDetailsInfoController.filter(
            function (a) {
              return a.BillType != 'RXBILL';
            });
          this.pdata = this.CurrentBillDetailsInfoControllernew;
          this.SelectedBillType = this.CurrentBillDetailsInfoController;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadOvaryData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  _LoadBillsGeneric() {
    var getReq = new x_BillDetailsRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.Branch = AppData.Instance().SelectedBranchCode;
    getReq.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    getReq.ToDate = new Date();
    getReq.ChargeEntry = 0;
    getReq.ConditionalOperator = 101053;
    getReq.BillType = '';
    getReq.FormattedCode = '';
    //getReq.SearchText = '';
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101053;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          this.CurrentBillDetailsInfoController = JSON.parse(data);
          this.CurrentBillDetailsInfoControllernew = this.CurrentBillDetailsInfoController.filter(
            function (a) {
              return a.BillType != 'RXBILL';
            });
          this.pdata = this.CurrentBillDetailsInfoControllernew;
          this.SelectedBillType = this.CurrentBillDetailsInfoController;
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  DecrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);

    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._LoadBillsGeneric();
    //this._GetBillDetailsInfoController();
    //ind++;
  }
  IncrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._LoadBillsGeneric();
    //this._GetBillDetailsInfoController();
    //ind++;
  }
  GenerateLabOrder() {

    //chrg entrty
    //lab order

    var saveReq = new SaveAdmissionLabDetails();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40260;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.AdmissionNo = this.ChargeEntryCode;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40260;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //if (this.ApiResData.Result[0].length > 0) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
          // then refresh
          //  this.LoadAdmissionServices();
          //this.activeModal.close();
          //}
          //else {
          //alertFunctions.AlertParam("Invalid Operation...!");
          //this.stopRefreshing();
          //}
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  EditReceipt(l: X_BillReceiptsController) {

    const modalRef = this.modalService.open(NgbPaymentModeChangeModal,
      {
        centered: true

      })
    modalRef.componentInstance.Receiptno = l.FormattedCode;
    modalRef.componentInstance.CompanyRe = l.CompanyReceiptCode;
    modalRef.componentInstance.Billno = l.BillFormattedCode;
    modalRef.componentInstance.PatientName = l.PatientName;
    modalRef.componentInstance.ReceiptDate = l.ReceiptDate;
    modalRef.componentInstance.PaymentInstructions = l.PaymentInstrument;
    modalRef.componentInstance.PatientAccountReceiptDetailCode = l.PatientAccountReceiptDetailCode;
    modalRef.result.then(x => { this.GetX_BillReceiptsController() })

  }
  Addopbill_withServiceProvider() {
    const modalRef = this.modalService.open(NgbSearchPatientModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.Frombills = true;
    modalRef.componentInstance.NotFrombills = false;
    modalRef.result.then((val: string) => {
      if (val != 'Cross click') {
        this.router.navigate(['healins/receipt_svcprovider', { FormattedCode: val }]);
      }
    });
  }
  Addopbill() {
    const modalRef = this.modalService.open(NgbSearchPatientModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.Frombills = true;
    modalRef.componentInstance.NotFrombills = false;
    modalRef.result.then((val: string) => {
      if (val != 'Cross click') {
        this.router.navigate(['healins/receiptold', { FormattedCode: val }]);
      }
    });
  }
  Addcommonbill() {
    const modalRef = this.modalService.open(NgbCombinebillSearchPatientModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.Frombills = true;
    modalRef.componentInstance.NotFrombills = false;
    modalRef.componentInstance.TypeofBill = "OP";
  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  //criteriaChange(value: any) {
  //    if (this.filter != null) {
  //        if (value != '[object Event]') {
  //            this.listFilter = value;
  //            //alert(this.listFilter);
  //            this.pdata = this.filter.transform(this.CurrentBillDetailsInfoController,
  //                this.listFilter);
  //        }
  //    }
  //}

  //criteriaChange(value:string) {
  //    //alert(event);
  //    this.Refreshpatients(value);
  //}
  pdata: any[];// = this.data;
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentBillDetailsInfoControllernew;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentBillDetailsInfoControllernew,
          this.listFilter);
      }
    }
  }
  RefreshLoadBillsGeneric(st: string) {
    var getReq = new x_BillDetailsRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.Branch = AppData.Instance().SelectedBranchCode;
    getReq.FromDate = new Date();
    getReq.ToDate = new Date();
    getReq.ChargeEntry = 0;
    getReq.ConditionalOperator = 101053;
    getReq.BillType = 'OPBILL';
    getReq.FormattedCode = '';
    getReq.SearchText = st;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101053;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          this.CurrentBillDetailsInfoController = JSON.parse(data);
          this.CurrentBillDetailsInfoControllernew = this.CurrentBillDetailsInfoController.filter(
            function (a) {
              return a.BillType != 'RXBILL';
            });
          this.pdata = this.CurrentBillDetailsInfoControllernew;
          this.SelectedBillType = this.CurrentBillDetailsInfoController;
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  Refreshpatients(st: string) {
    this.Currentx_BillDetailsRequest = new x_BillDetailsRequest();
    this.Currentx_BillDetailsRequest.SearchText = st;
    this.Currentx_BillDetailsRequest.ConditionalOperator = 20;
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.Currentx_BillDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    // this.pdata = this.CurrentBillDetailsInfoController;
    this._GetBillDetailsInfoControllerSearch();
  }
  _GetBillDetailsInfoControllerSearch() {
    this.StartRefreshing();
    //this.spinner.show();
    this.Currentx_BillDetailsRequest.Branch = AppData.Instance().SelectedBranchCode;
    this.Currentx_BillDetailsRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.Currentx_BillDetailsRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.Currentx_BillDetailsRequest.ChargeEntry = 0;
    //this.Currentx_BillDetailsRequest.ConditionalOperator = 10;
    this.Currentx_BillDetailsRequest.BillType = '';
    this.Currentx_BillDetailsRequest.FormattedCode = '';
    //alert(this.FormattedCode);
    this.actorservice.GetBillDetailsInfoController(this.Currentx_BillDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentBillDetailsInfoController = this.ApiResData.Result;
          //this.pdata = this.CurrentBillDetailsInfoController;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadOvaryData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  header() {
    let m = document.querySelector("#header");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  items() {
    let m = document.querySelector("#items");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  Receipts() {
    let m = document.querySelector("#Receipts");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  billedit() {
    //alert("hello2");
    const fmtCode = this.SelectedpatientDetails ? (this.SelectedpatientDetails.PatientFormattedCode || this.SelectedpatientDetails.FormattedCode) : '';
    this.router.navigate(['healins/receiptedit', { FormattedCodedata: fmtCode, ChargeEntryCode: this.ChargeEntryCode, BillStatus: this.CurrentX_BillHeaderController ? this.CurrentX_BillHeaderController.BillStatus : '' }]);
  }
  billeditSvcProvider() {
    //alert("hello2");
    const fmtCode = this.SelectedpatientDetails ? (this.SelectedpatientDetails.PatientFormattedCode || this.SelectedpatientDetails.FormattedCode) : '';
    this.router.navigate(['healins/receiptedit_svcprovider', { FormattedCodedata: fmtCode, ChargeEntryCode: this.ChargeEntryCode, BillStatus: this.CurrentX_BillHeaderController ? this.CurrentX_BillHeaderController.BillStatus : '' }]);
  }
  ClearInput() {
    this.searchValue = '';
    // this.searchValue = null;
    //var searchtext = '';
    //this.Refreshpatients(this.searchValue);
    this.RefreshLoadBillsGeneric(this.searchValue);
  }
  //opbill() {
  //  if (this.CurrentX_BillItemsController != null) {
  //    if (this.CurrentX_BillItemsController.length > 4) {
  //      this.printService.printDocument("opbill",
  //        {
  //          ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
  //          Branch: this.SelectedpatientDetails.BranchName, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

  //        },

  //      );
  //    }
  //    else {
  //      this.A5opbill();
  //    }
  //  }
  //}
  opbill() {
    this.printService.printDocument2(this.SelectedpatientDetails.PatientFormattedCode, 0

    );
    this.printService.printDocument3(this.SelectedpatientDetails.BillNo, 0

    );
    this.printService.printDocument("opbill",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry,
        PatientId: this.SelectedpatientDetails.PatientFormattedCode,
        Owner: this.SelectedpatientDetails.PatientName,
        Gender: this.SelectedpatientDetails.PatientGender,
        Age: this.SelectedpatientDetails.PatientAgeY,
        BillDate: this.SelectedpatientDetails.BillDate,
        BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName,
        ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode,
        GrandTotal: this.SelectedpatientDetails.TotalAmount,
        Discount: this.SelectedpatientDetails.Discount,
        Tax: this.SelectedpatientDetails.Tax,
        Net: this.SelectedpatientDetails.Net,
        Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  opbillSvc_Provider() {
    this.printService.printDocument2(this.SelectedpatientDetails.PatientFormattedCode, 0

    );
    this.printService.printDocument3(this.SelectedpatientDetails.BillNo, 0

    );
    this.printService.printDocument("opbillSvc_Provider",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry,
        PatientId: this.SelectedpatientDetails.PatientFormattedCode,
        Owner: this.SelectedpatientDetails.PatientName,
        Gender: this.SelectedpatientDetails.PatientGender,
        Age: this.SelectedpatientDetails.PatientAgeY,
        BillDate: this.SelectedpatientDetails.BillDate,
        BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName,
        ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode,
        GrandTotal: this.SelectedpatientDetails.TotalAmount,
        Discount: this.SelectedpatientDetails.Discount,
        Tax: this.SelectedpatientDetails.Tax,
        Net: this.SelectedpatientDetails.Net,
        Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  ipadvbill() {
    this.printService.printDocument2(this.SelectedpatientDetails.PatientFormattedCode, 0

    );
    this.printService.printDocument3(this.SelectedpatientDetails.BillNo, 0

    );
    this.printService.printDocument("advreceipt",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName, ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  opadvbill() {
    this.printService.printDocument2(this.SelectedpatientDetails.PatientFormattedCode, 0

    );
    this.printService.printDocument3(this.SelectedpatientDetails.BillNo, 0

    );
    this.printService.printDocument("advreceipt",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName, ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  rxbill() {
    //alert("hello");
    this.printService.printDocument2(this.SelectedpatientDetails.PatientFormattedCode, 0

    );
    this.printService.printDocument3(this.SelectedpatientDetails.BillNo, 0

    );
    this.printService.printDocument("pharmacybill",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName, ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  A5opbill() { // a5 print
    //alert("hello");
    this.printService.printDocument3(this.SelectedpatientDetails.BillNo, 0

    );
    this.printService.printDocument("A5opbill",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName, ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  A5opbillSvc_Provider() { // a5 print
    //alert("hello");
    this.printService.printDocument3(this.SelectedpatientDetails.BillNo, 0

    );
    this.printService.printDocument("A5opbillSvc_Provider",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName, ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  A5ipadvbill() {
    //alert("hello");
    this.printService.printDocument3(this.SelectedpatientDetails.BillNo, 0

    );
    this.printService.printDocument("A5advrcpt",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName, ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  A5opadvbill() {
    //alert("hello");
    this.printService.printDocument3(this.SelectedpatientDetails.BillNo, 0

    );
    this.printService.printDocument("A5advrcpt",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName, ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  A5rxbill() {
    //alert("hello");
    this.printService.printDocument3(this.SelectedpatientDetails.BillNo, 0

    );
    this.printService.printDocument("A5rxbill",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName, ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
}
